import { makeObservable, observable, observe } from "mobx";
import { ViewModelBase } from "@shoothill/core";
import { APIClient, RelayCommand } from "Application";
import { BuildprogressModel, BuildprogressModelValidator } from "./BuildprogressModel";
import { Logger } from "index";
import { StagesModel } from "./Stages/StagesModel";
import { StagesViewModel } from "./Stages/StagesViewModel";
import { GETBuildProgressEndpoint } from "./Endpoints/GETBuildProgressEndpoint";
import { AccountStore } from "../../Stores/Domain";
import { container } from "tsyringe";

export class BuildprogressViewModel extends ViewModelBase<BuildprogressModel> {
    private accountStore = container.resolve(AccountStore);
    public apiClient = new APIClient();
    public stagesViewModels = observable<StagesViewModel>([]);

    constructor(model = new BuildprogressModel()) {
        super(model);
        this.setValidator(new BuildprogressModelValidator());
        makeObservable(this, {});
        this.apiClient.sendAsync(new GETBuildProgressEndpoint(this, this.accountStore.CoinsPlotId!), this.model);
    }

    public dispose = (): void => {
        this.stagesModelsObserverDispose();
    };

    public get buildProgressList() {
        const project = this.stagesViewModels.filter((item) => item.model.isVisible);
        return project;
    }

    private stagesModelsObserverDispose = observe(this.model.stagesModels, (childModelChanges: any) => {
        Logger.logDebug(`StagesViewModel.childModelsObserverDispose`);
        for (const addedChildModel of childModelChanges.added) {
            this.stagesViewModels.push(new StagesViewModel(addedChildModel));
        }

        for (const removedChildModel of childModelChanges.removed) {
            const childViewModelToRemove = this.stagesViewModels.find((vm) => vm.model.KEY === removedChildModel.KEY);

            if (childViewModelToRemove) {
                this.stagesViewModels.remove(childViewModelToRemove);
            }
        }
    });

    //#region Update Commands
    public addStagesCommand = new RelayCommand(() => {
        this.model.stagesModels.push(new StagesModel());
    });

    //#endregion Commands
}
